const price = `
    price_range {
        minimum_price {
            regular_price {
                value
                currency
            }
            final_price {
                value
                currency
            }
            discount {
                percent_off
                amount_off
            }
        }
    }
`;

const getProductVariants = sku => `
    {
        products(filter: { sku: { eq: "${sku}" } }) {
            items {
                ... on ConfigurableProduct {
                    variants {
                        attributes {
                            label
                            value_index
                        }
                        product {
                            name
                            sku
                            stock_status
                            stock_data {
                                max_sale_qty
                            }
                            default_product_size
                            display_weight
                            weight
                            image {
                                url
                                label
                            }
                            comparison_unit
                            qty_comparison
                            ${price}
                        }
                    }
                }
            }        
        }
    }
`;

export default {
    getProductVariants,
};
